<template>
  <pull-to
    ref="pullToContainer"
    :top-config="topConfig"
    :is-bottom-bounce="false"
    :is-top-bounce="allowPullToRefresh"
    :top-load-method="loadMethod"
    :top-block-height="60"
    @top-state-change="stateChange"
  >
    <template slot="top-block">
      <v-layout row nwrap justify-center>
        <v-progress-circular
          :size="24"
          :width="2"
          color="switchq"
          value="70"
          :indeterminate="loadingIcon == 'trigger' ? true : false"
        ></v-progress-circular>
      </v-layout>
    </template>
    <v-container class="pa-0 pt-0" style="overflow-y: auto">
      <div v-if="searchDevices == '' || !searchDevices">
        <v-layout
          :class="
            $vuetify.breakpoint.xs
              ? 'd-flex flex-row mt-3 justify-space-around'
              : 'd-flex flex-row mt-3 justify-space-around'
          "
          wrap
        >
          <!-- :loading="devicesStore.loading" -->
          <v-col
            :class="
              $vuetify.breakpoint.xs
                ? 'mt-3 main-card pointer flex-grow-1' +
                  (!this.$userPermissions.permitted('automations')
                    ? ' biggerCard'
                    : '')
                : 'main-card pointer'
            "
          >
            <base-nice-card
              :title="content.devices"
              icon="mdi-router-wireless"
              :subtitle="content.totalDevices"
              :subtitle_value="Object.values(items).length"
              to="devices"
              color="purple"
              subtitle_color="purple-lighten-2"
              parameters_color="purple-accent-3"
              :parameters="[
                {
                  key: content.connected,
                  value: Object.values(items).filter(
                    (item) => item.online == true
                  ).length,
                  size: 4,
                },
              ]"
            />
          </v-col>
          <v-col
            :class="
              $vuetify.breakpoint.xs
                ? 'mt-3 main-card pointer flex-grow-0 flex-shrink-1'
                : 'main-card pointer'
            "
          >
            <base-nice-card
              :title="content.gateways"
              icon="mdi-router-network"
              :subtitle="content.totalGates"
              :subtitle_value="mappedGateways.length"
              to="gateways"
              color="blue"
              subtitle_color="blue-lighten-2"
              parameters_color="blue-accent-3"
              :parameters="[
                {
                  key: content.connectedGates,
                  value: mappedGateways.filter((item) => item.online == true)
                    .length,
                  size: 4,
                },
              ]"
            />
          </v-col>
          <v-col
            v-if="this.$userPermissions.permitted('automations')"
            :class="
              $vuetify.breakpoint.xs
                ? 'mt-3 main-card pointer flex-grow-0 flex-shrink-1'
                : 'main-card pointer'
            "
          >
            <base-nice-card
              :title="content.autos"
              icon="mdi-refresh-auto"
              :subtitle="content.totalAutos"
              :subtitle_value="Object.values(automations).length"
              to="/automations"
              color="orange"
              subtitle_color="orange-lighten-2"
              parameters_color="orange-accent-3"
              :parameters="[
                {
                  key: content.active,
                  value: Object.values(automations).filter(
                    (item) => item.status == 1
                  ).length,
                  size: 4,
                },
              ]"
            />
          </v-col>
          <v-col
            :class="
              $vuetify.breakpoint.xs
                ? 'mt-3 main-card pointer flex-grow-0 flex-shrink-1'
                : 'main-card pointer'
            "
          >
            <base-nice-card
              :title="content.exceeds"
              icon="mdi-alert-circle-outline"
              :subtitle="content.totalEx"
              :subtitle_value="
                Object.values(items).filter((item) => item.exceeds).length
              "
              to="/devices/exceeds"
              color="red"
              subtitle_color="red-lighten-2"
              parameters_color="red-accent-3"
              :parameters="[
                {
                  key: content.malfunction,
                  value: Object.values(items).filter(
                    (item) => item.malfunction.status == 2
                  ).length,
                  size: 4,
                },
                // icon: 'mdi-router-wireless',
              ]"
            />
          </v-col>
        </v-layout>
        <!-- <v-layout class="d-flex mt-8" row wrap justify-space-around> </v-layout> -->
        <v-layout
          :class="
            $vuetify.breakpoint.xs
              ? 'd-flex mt-8 align-top justify-items-center'
              : 'd-flex mt-8 align-top justify-space-around'
          "
          row
          wrap
        >
          <v-flex xs12 md5>
            <ProblemsCard :notifications="problemCardNotifications" />
          </v-flex>
          <v-flex xs12 md5>
            <v-card
              :class="
                $vuetify.breakpoint.xs
                  ? 'mt-8 mx-auto dashNotifications'
                  : 'dashNotifications'
              "
            >
              <!-- <router-link to="/profile/notifications">
              </router-link> -->
              <h3
                class="text-center py-2 switchqSub--text pointer switchq lighten-1"
                @click="openNotifications"
              >
                <v-layout row wrap justify-space-between>
                  <v-flex xs2>
                    <Icon icon="notificationsBell" color="white" />
                  </v-flex>
                  <v-flex xs8>
                    {{ content.lastNotifications }}
                  </v-flex>
                  <v-flex xs2 />
                </v-layout>
              </h3>
              <v-layout row wrap v-if="loading">
                <v-flex xs12 class="list-item text-xs-center pa-0">
                  <v-progress-linear
                    :indeterminate="true"
                    class="my-0"
                  ></v-progress-linear>
                </v-flex>
              </v-layout>
              <v-layout
                column
                class="notifications-list"
                ref="notifications"
                v-if="!loading"
              >
                <v-flex
                  xs12
                  v-for="(not, index) in notifications"
                  :key="index"
                  class="notification-row pt-2 px-2"
                >
                  <v-layout
                    column
                    wrap
                    @click="not ? openPage(not) : ''"
                    class="pointer"
                  >
                    <v-flex xs12 class="text-subtitle-2">
                      <strong v-if="not.msg_body">
                        {{ not.msg_body }}
                      </strong>
                      <!-- <strong v-if="!not.data.device">{{ not.data.body }}</strong> -->
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row wrap justify-end>
                        <small dir="rtl" class="grey--text text--darken-1">
                          <!-- {{ new Date(not.created_at).toLocaleTimeString() }} -->
                          {{ not.created_at }}
                        </small>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex
                  xs12
                  class="list-item text-center pa-3"
                  v-if="notifications && notifications.length == 0"
                >
                  <strong class="text-xs-center">{{ content.nonew }}</strong>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </div>

      <div v-if="searchDevices">
        <v-layout
          v-if="Object.keys(items).length"
          row
          wrap
          justify-center
          id="devicesMain"
        >
          <v-flex
            px-2
            xs12
            md6
            v-if="
              !selectedItem ||
              (selectedItem &&
                $vuetify.breakpoint.mdAndUp &&
                searchDevices != '')
            "
            :id="selectedItem ? 'devices' : 'devices-xs'"
            :class="dir === 'rtl' ? 'd-r' : 'd-l'"
          >
            <v-layout column wrap>
              <v-expand-transition>
                <v-flex
                  v-show="
                    ($vuetify.breakpoint.smAndUp || showViewEdit) &&
                    Object.keys(items).length &&
                    !inGroup
                  "
                  xs12
                  class="mb-2"
                >
                  <v-layout
                    row
                    wrap
                    justify-space-between
                    align-content-center
                    align-center
                  >
                    <small class="px-3">
                      {{ content.countdevices }}: {{ Object.keys(items).length
                      }}<span v-if="countalldevices > Object.keys(items).length"
                        >/{{ countalldevices }}</span
                      >
                    </small>
                    <v-btn
                      v-if="!inGroup && (searchDevices == '' || !searchDevices)"
                      text
                      small
                      class="btn-xs"
                      color="info"
                      @click="$router.push('/edit-view')"
                      >{{ content.editview }}</v-btn
                    >
                  </v-layout>
                </v-flex>
              </v-expand-transition>

              <v-flex
                grow
                v-for="(item, index) in items"
                :key="item ? item.slug : index"
                class="mb-3 white device-wrapper"
              >
                <DeviceBar
                  @click="openItem(item.slug)"
                  :item="item"
                  :index="index"
                  :inGroup="inGroup"
                  :group="group"
                />
              </v-flex>
            </v-layout>
            <v-flex
              xs10
              row
              mt-5
              justify-start
              v-if="inGroup && $vuetify.breakpoint.mdAndDown"
            >
            </v-flex>
          </v-flex>

          <v-flex
            ref="devicePage"
            v-if="selectedItem && items[selectedItem]"
            xs12
            md6
            :class="dir === 'rtl' ? 'divide-r' : 'divide-l'"
            :id="$vuetify.breakpoint.mdAndUp ? 'device' : ''"
          >
            <router-view
              :dir="dir"
              :key="selectedItem"
              :locale="locale"
            ></router-view>
          </v-flex>
        </v-layout>
      </div>
    </v-container>
  </pull-to>
</template>

<script>
import DeviceBar from "@/components/devices/DeviceBar.vue";
import BaseNiceCard from "@/components/app_parts/NiceCard.vue";
import ProblemsCard from "@/components/app_parts/ProblemsCard.vue";
import PullTo from "vue-pull-to";
import Lang from "@/helpers/lang";
import dayjs from "@/plugins/dayjs";
// import userPermission from "@/helpers/userPermission";
export default {
  components: {
    DeviceBar,
    BaseNiceCard,
    ProblemsCard,
    PullTo,
  },

  data() {
    return {
      orders: {},
      sliceMore: 0,
      locale: Lang.get(),
      content: {},
      selectedItem: null,
      scroll: 0,
      pulled: 0,
      scrollInterval: null,
      scrollY: 0,
      showViewEdit: true,
      freeToRefresh: false,
      loadingIcon: null,
      displayBackBtn: false,
      mainDash: true,
      loading: true,
      topConfig: {
        pullText: this.$t("pullTo"),
        triggerText: this.$t("releaseTo"),
        loadingText: this.$t("refresh"),
        failText: this.$t("refreshFail"),
        triggerDistance: 70,
      },
    };
  },
  computed: {
    dir() {
      return this.$vuetify.rtl ? "rtl" : "ltr";
    },
    searchDevices() {
      let search = this.$store.getters["devices/deviceSearch"];
      if (search && search != "") {
        search = search.trim().toLowerCase();
      }
      return search;
    },
    devices() {
      return this.$store.getters["devices/alldevices"];
    },
    automations() {
      return this.$store.getters["automations/automationsObj"];
    },
    gateways() {
      return this.$store.getters["gateways/gateways"];
    },
    user() {
      return this.$store.getters["user/user"];
    },
    notifications() {
      const DEVICES = this.devices;
      const GATEWAYS = this.gateways;
      const notifications = JSON.parse(
        JSON.stringify(this.$store.getters["notifications/notifications"])
      );
      // console.log("not111111111111111111111111111111: ", notifications);
      return notifications.map((not) => {
        // console.log("not111111111111111111111111111111: ", not);
        let gateway = Object.values(GATEWAYS).filter(
          (g) => g.slug == not.gateway_identifier
        )[0];
        if (DEVICES[not.device_identifier]) {
          not.device_slug = DEVICES[not.device_identifier].slug;
          not.device_name = DEVICES[not.device_identifier].name;
          not.device_identifier = DEVICES[not.device_identifier].identifier;
        }
        if (gateway) {
          not.gateway_identifier = gateway.mac;
          not.gateway_slug = gateway.slug;
          if (not.gateway_name) {
            not.gateway_name = gateway.names.length
              ? gateway.names.filter((g) => g.user == this.user.slug)[0].name
              : gateway.mac;
          }
        }
        if (not.device_name || not.gateway_name) {
          not.name = not.device_name ? not.device_name : not.gateway_name;
        }
        if (not.created_at) {
          not.created_at = dayjs(not.created_at).format("DD/MM/YY - HH:mm");
          not.read_at = dayjs(not.read_at).format("DD/MM/YY - HH:mm");
        }
        return not;
      });
    },
    problemCardNotifications() {
      let offlineDevices = Object.values(this.items)
        .filter((item) => item.online != true)
        .map((item) => {
          return {
            identifier: item.identifier,
            name: item.name || "",
            alert: "Offline",
            received: item.received,
            msg_body: {
              he: "שידור אחרון",
              en: "Last seen",
            },
          };
        });
      let exceedsDevices = Object.values(this.items)
        .filter((item) => item.exceeds)
        .map((item) => {
          return {
            identifier: item.identifier,
            name: item.name || "",
            alert: "Exceeds",
            type: item.exceedsRule,
            value: item.exceedsVal,
            msg_body: {
              he:
                item.exceedsRule == "hall" || item.exceedsRule == "magnet"
                  ? "חיישן " + this.$t(item.exceedsRule)
                  : "חיישן " +
                    this.$t(item.exceedsRule) +
                    " חורג מהסף " +
                    (item.exceedsRule == "humidity" ? "%" : "℃"),
              en:
                item.exceedsRule == "hall" || item.exceedsRule == "magnet"
                  ? "Sensor " + this.$t(item.exceedsRule)
                  : "Sensor " +
                    this.$t(item.exceedsRule) +
                    " exceeds the value " +
                    (item.exceedsRule == "humidity" ? "%" : "℃"),
            },
          };
        });
      let malfunctionDevices = Object.values(this.items)
        .filter((item) => item.malfunction.status == 2)
        .map((item) => {
          return {
            identifier: item.identifier,
            name: item.name || "",
            alert: "Malfunctioned",
            msg_body: {
              he:
                item.malfunction.value != "-50"
                  ? "חיישן הטמפרטורה תקול"
                  : "חיישן הטמפרטורה קרוע",
              en:
                item.malfunction.value != "-50"
                  ? "The temparture is malfunctioned"
                  : "the device is torn",
            },
          };
        });
      let offlineGateways = this.mappedGateways
        .filter((item) => item.online != true)
        .map((item) => {
          return {
            identifier: item.identifier,
            name: item.name || "",
            alert: "OfflineGate",
            received: this.formatTime(item.last_received_at.received_at),
            msg_body: {
              he: "שידור אחרון",
              en: "Last seen",
            },
          };
        });
      let lowBattery = Object.values(this.items)
        .filter((item) => item.data && item.data.battery)
        .filter((item) => {
          return (
            (item.data.battery.type == "percent" &&
              parseFloat(item.data.battery.value) <= 40) ||
            (item.data.battery.type == "voltage" &&
              parseFloat(item.data.battery.value) <= 2.8)
          );
        })
        .map((item) => {
          // console.log("item: ", item);
          return {
            identifier: item.identifier,
            battery: item.data.battery,
            name: item.name,
            alert: "Low battery",
            // type: item.data.battery.symbol,
            msg_body: {
              he:
                item.data.battery.type == "percent"
                  ? item.data.battery.string
                  : parseFloat(item.data.battery.value) <= 2.7
                  ? "מתחת ל20%"
                  : "מתחת ל40%",
              en:
                item.data.battery.type == "percent"
                  ? item.data.battery.string
                  : parseFloat(item.data.battery.value) <= 2.7
                  ? "Below 20%"
                  : "Below 40%",
            },
          };
        });
      let nots = {
        offlineGates: offlineGateways,
        offlineDevs: offlineDevices,
        exceeds: exceedsDevices,
        malfunctioned: malfunctionDevices,
        low: lowBattery,
      };
      // console.log("notifications: ", nots);
      return nots;
    },
    inGroup() {
      let inGroup = localStorage.getItem("inGroup");
      if (inGroup == "true") {
        return true;
      }
      return false;
    },
    group() {
      return this.inGroup
        ? this.$store.getters["groups/group"](this.$route.params.gslug)
        : null;
    },
    groups() {
      return this.$store.getters["groups/groups"];
    },
    total() {
      return this.$store.getters["notifications/total"];
    },
    gatewaysNames() {
      return this.$store.getters["devices/gNames"];
    },
    mappedGateways() {
      let loop = 0;
      let returnGateways = this.$store.getters["devices/gateways"];
      returnGateways = Object.values(returnGateways)
        .map((gateway) => {
          let g = this.$store.getters["gateways/gateway"](gateway.identifier);
          gateway.own =
            g && g.users
              ? g.users
                  .map((u) => {
                    return u.email;
                  })
                  .includes(this.$store.getters["user/user"].email)
              : false;
          gateway.totalDevices = gateway.devices.length;
          gateway.avgRssi =
            gateway.devices.reduce((total, next) => total + next.rssi, 0) /
            gateway.devices.length;
          gateway.avgRssi = Number(gateway.avgRssi).toFixed(0);
          gateway.last_received_at = this.findMaxValueObject(
            gateway.devices,
            "received_at"
          );
          gateway.online = this.isOnlineByReceivedAt(
            gateway.last_received_at?.received_at,
            60 // <-- threshold minutes (change as you want)
          );
          if (
            this.gatewaysNames.filter(
              (gn) => gn.gateway == gateway.identifier
            )[0]
          ) {
            gateway.name = JSON.parse(
              JSON.stringify(this.gatewaysNames)
            ).filter((gn) => gn.gateway == gateway.identifier)[0].name;
          }
          return gateway;
        })
        .filter((g) => {
          return !this.isOlderThan2Weeks(g.last_received_at.received_at);
        })
        .map((gateway) => {
          if (!(gateway.identifier in this.orders)) {
            this.orders[gateway.identifier] = loop; // if the gateway doesn't exist in orders, add it and set its order to the loop index.
          }
          gateway.order = this.orders[gateway.identifier];
          loop++;
          return gateway;
        });
      let sliceMore = this.sliceMore != 0 ? this.sliceMore : 0;
      if (sliceMore == 0) {
        sliceMore = returnGateways.filter((g) => {
          let lastReceivedAt = new Date(g.last_received_at.received_at);
          //return if lastReceivedAt is the last 3 days
          const THREE_DAYS_MS = 3 * 24 * 60 * 60 * 1000;

          return Date.now() - lastReceivedAt.getTime() <= THREE_DAYS_MS;
        }).length;
      }
      return returnGateways.slice(0, sliceMore);
    },
    items() {
      let devices = {};
      const search = this.searchDevices;
      devices = this.$store.getters["devices/devices"] || {};
      if (search && search.length > 0) {
        devices = Object.values(devices).filter((d) => {
          let groups = this.$store.getters["groups/getGroupsByDevice"](d.slug);
          return (
            d.identifier.toLowerCase().includes(search) ||
            d.name.toLowerCase().includes(search) ||
            groups.join(",").toLowerCase().includes(search)
          );
        });
        let result = {};
        for (let i = 0; i < devices.length; i++) {
          result[devices[i].slug] = devices[i];
        }
        devices = result;
      }
      // }
      return devices;
    },
    countalldevices() {
      return this.$store.getters["devices/devicesCount"];
    },
    loadMethod() {
      return (this.showViewEdit || this.$route.params.slug) &&
        this.scrollY === 0
        ? this.refresh
        : null;
    },
    allowPullToRefresh() {
      return this.$vuetify.breakpoint.smAndDown && this.scrollY === 0;
    },
  },
  async created() {
    this.setLang();
    await this.$store.dispatch("notifications/fetchNotificationsDash", {
      page: 1,
      // itemsPerPage: this.$vuetify.breakpoint.xs ? 20 : 20,
      time: 24,
    });
    this.loading = false;
    this.notifications;
    if (this.$route.params.slug) {
      if (!this.items[this.$route.params.slug]) {
        this.$router.push("/");
      } else {
        this.selectedItem = this.$route.params.slug;
      }
    }
  },
  mounted() {
    // console.log(
    //   "userPermission:",
    //   this.$userPermissions.permitted("automations")
    // );
    this.$vuetify.goTo(0, { duration: 0 });
    if (this.$vuetify.breakpoint.smAndDown) {
      this.scrollInterval = setInterval(() => {
        this.scrollY = window.scrollY;
      }, 100);
    }
  },
  destroyed() {
    clearInterval(this.scrollInterval);
  },
  watch: {
    notifications() {
      // console.log(this.notifications);
      if (this.notifications.length > 0) {
        this.loading = false;
      }
    },
    $route() {
      if (
        this.$route.params.slug == null ||
        this.$route.params.slug == undefined
      ) {
        this.selectedItem = null;
        if (this.$vuetify.breakpoint.smAndDown)
          this.$vuetify.goTo(0, { duration: 0 });
      } else {
        this.openItem(this.$route.params.slug);
        this.$vuetify.goTo(0, { duration: 0 });
      }
    },
    items() {
      this.items;
    },
    // isMainDash: {
    //   handler() {},
    //   deep: true,
    // },
  },
  methods: {
    isOnlineByReceivedAt(dateStr, thresholdMinutes = 5) {
      if (!dateStr) return false;
      const t = new Date(dateStr).getTime();
      if (Number.isNaN(t)) return false;

      const now = Date.now();
      const diffMs = now - t; // if negative = future timestamp
      return diffMs >= 0 && diffMs <= thresholdMinutes * 60 * 1000;
    },
    findMaxValueObject(array, key) {
      if (array.length === 0) return null;
      return array.reduce((maxObject, currentObject) =>
        currentObject[key] > maxObject[key] ? currentObject : maxObject
      );
    },
    isOlderThan2Weeks(receivedTime) {
      const currentTime = new Date();
      const threeWeeksAgo = new Date(
        currentTime.getTime() - 2 * 7 * 24 * 60 * 60 * 1000
      ); // 2 weeks in milliseconds
      return new Date(receivedTime) < threeWeeksAgo;
    },
    openPage(not) {
      if (not.gateway_identifier) {
        this.$router.push("/gateways/" + not.gateway_identifier);
      }
      if (not.device_slug) {
        this.$router.push("/devices/" + not.device_slug);
      }
      if (!not.device_slug && not.device_identifier) {
        this.$router.push("/devices/" + not.device_identifier);
      }
      localStorage.setItem("homePage", "mainDash");
      this.$store.dispatch("devices/setSearchDevice", null);
      // this.menu = false;
    },
    openNotifications() {
      // this.menu = false;
      this.$router.push("/profile/notifications");
    },
    refresh() {
      if (this.showViewEdit) {
        window.location.href = "";
      }
    },
    stateChange(state) {
      if (this.showViewEdit) {
        if (state === "pull") {
          this.loadingIcon = "pull";
        } else if (state === "trigger") {
          this.loadingIcon = "trigger";
        }
      }
    },
    formatTime(time) {
      return dayjs(time).isValid()
        ? dayjs(time).format("HH:mm:ss DD/MM/YYYY")
        : time;
    },
    // openItem(slug) {
    //   this.selectedItem = slug;
    //   let path = this.inGroup ? "/groups/" + this.group.slug : "";
    //   path += "/devices/" + slug;
    //   this.$store.dispatch("devices/setSearchDevice", "");
    //   if (this.$route.path !== path) {
    //     this.$router.push({ path: path });
    //   }
    // },
    setLang() {
      if (this.locale == "en") {
        this.content = {
          gateways: "Gateways",
          totalGates: "Total:",
          devices: "Devices",
          totalDevices: "Total:",
          connected: "Connected",
          connectedGates: "Connected",
          exceeds: "Exceeds Devices",
          totalEx: "Total:",
          malfunction: "Malfunctioning",
          autos: "Automations",
          totalAutos: "Total:",
          active: "Active",
          countdevices: "Number of devices",
          editview: "edit view",
          addDevices: "add switches",
          editGroup: "edit group",

          empty: {
            group: "The group don't have registered switches yet!",
            title: "You don't have any switches registered yet!",
            subtitle: "Click here to register a new switch",
            btn: "Register A New Switch",
            empty: "The group is empty!",
            sectitle: "All of our devices are hidden",
            clickto: "Click here to ",
          },
          notifications: "Notifications",
          lastNotifications: "Last 24H Notifications",
          scrolldown: "scroll down",
          nonew: "No notifications in the last 24 hours",
          type: {
            NotConnected: "Lost power or internet connection",
            IsConnected: "The power or internet connection is back",
            NoSensor: "The sensor has disconnected",
            ForbiddenArea: "Is in a forbidden area",
            MetTreshold: "Reached the threshold you set",
            FixedMetTreshold: "The indicators returned to normal",
            FloodSuspected: "The buoy identifies flooding",
            FloodFixed: "The buoy is back to normal",
            DoorOpened: "The sensor detected a door opening",
            DoorClosed: "The sensor detected a door closing",
            SmokeAlarm: "Warning of smoke!",
            MotionDetected: "Detects motion!",
            LowBattery: "The device has low battery",
          },
        };
      } else if (this.locale == "he") {
        this.content = {
          gateways: "מרכזיות",
          totalGates: "סה''כ מרכזיות:",
          devices: "מכשירים",
          totalDevices: "סה''כ מכשירים:",
          connected: "מחוברים",
          connectedGates: "מחוברות",
          exceeds: "מכשירים חורגים",
          totalEx: "סה''כ:",
          malfunction: "תקולים",
          autos: "אוטומציות",
          totalAutos: "סה''כ אוטומציות:",
          active: "פעילות",
          countdevices: "מספר מכשירים",
          editview: "עריכת תצוגה",
          addDevices: "הוספת מכשירים",
          editGroup: "עריכת קבוצה",

          empty: {
            group: "עדיין לא נוספו מכשירים לקבוצה!",
            title: "עדיין לא רשומים אצלך מכשירים!",
            subtitle: "לחץ כאן כדי לרשום מכשיר חדש",
            btn: "הוספת מכשיר חדש",
            empty: "קבוצה זו עדיין ריקה",
            sectitle: "כל המכשירים הרשומים אצלך מוסתרים.",
            clickto: "לחץ כאן ל",
          },
          notifications: "התראות",
          lastNotifications: "התראות ב24 שעות אחרונות",
          scrolldown: "גלול למטה",
          nonew: "אין התראות ב-24 שעות אחרונות להצגה",
          type: {
            NotConnected: "איבד חיבור לחשמל או לאינטרנט",
            IsConnected: "חזר החיבור לחשמל או לאינטרנט",
            NoSensor: "החיישן לא מחובר",
            ForbiddenArea: "נמצא באזור אסור",
            MetTreshold: "הגיע לסף שהגדרת",
            FixedMetTreshold: "המדדים חזרו למצב תקין",
            FloodSuspected: "המצוף מזהה הצפה",
            FloodFixed: "המצוף חזר למצב תקין",
            DoorOpened: "החיישן מזהה פתיחה של דלת",
            DoorClosed: "החיישן מזהה סגירה של דלת",
            SmokeAlarm: "אזהרת עשן!",
            MotionDetected: "מזהה תנועה!",
            LowBattery: "למכשיר יש סוללה חלשה",
          },
        };
      }
    },
  },
};
</script>

<style lang="css" scoped>
.dashNotifications {
  width: 70vw;
  max-height: 284px;
  overflow-y: auto;
}
.btn-xs {
  height: 16px;
}

.inGroupHeader {
  margin-bottom: -12px;
}

.backBtn {
  background-position: top;
  margin-bottom: 10px;
  padding: 0px 30px 30px 0px;
  position: fixed;
  bottom: 0px;
}

.display {
  text-align: center;
}

.device-wrapper {
  border-radius: 5px;
}
.switchBar {
  min-height: 50px;
  /* border-radius: 5px; */
}

.itemTitle {
  font-size: 11pt;
}

.pt-0 {
  margin-top: -5px;
}

.dryContact {
  max-height: 20px;
  /* max-width: 30px; */
  width: auto;
}

.maxWidthWithBtns {
  max-width: calc(100vw - 165px);
}
.itemBtns .minWidth160 {
  min-width: 120px;
}

.layout.itemBtns.row.wrap.justify-end.align-center.shrink {
  font-size: 13pt;
}

@media screen and (max-width: 600px) {
  .dashNotifications {
    width: 90vw;
  }
  #devices-xs {
    margin-top: 15px;
    height: fit-content;
  }
  .itemTitle,
  .limitWidth {
    width: 100%;
    /* max-width: calc(100vw - 186px); */
  }
  #devicesMain {
    /* min-height: calc(96vh - (48px + 56px)); */
    height: fit-content;
  }
}
@media screen and (min-width: 600px) {
  #devices {
    padding: 0 15px;
  }
  /* #devices,
  #device {
    overflow-y: auto;
    max-height: calc(100vh - 195px);
  } */
  #devices::-webkit-scrollbar,
  #device::-webkit-scrollbar {
    scrollbar-width: 0px;
    width: 1em;
    display: none;
  }
}
@media screen and (min-width: 960px) {
  .d-r,
  .divide-l {
    padding-left: 15px;
  }
  .d-l,
  .divide-r {
    padding-right: 15px;
  }
  .divide-l {
    border-left: 2px solid #e9e9e9;
  }
  .divide-r {
    border-right: 2px solid #e9e9e9;
  }
}

.notdevicesbtn {
  font-size: 14pt;
}
.main-card {
  max-width: 360px;
  display: flex;
  justify-content: center;
}
.biggerCard {
  min-width: 310px;
}
</style>
